import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {TasksReportFilters} from '../../../../Models/Reports/Tasks/Shared/tasks-report-filters.model';
import {TaskDetailReportParamsDto} from '../../../../Models/Reports/Tasks/Shared/task-detail-report.interface';
import {ChecklistsReportModelService} from '../../../Models/Reports/Tasks/checklists-report-model.service';
import {AuditReportModelService} from '../../../Models/Reports/Tasks/audit-report-model.service';
import {AppccReportModelService} from '../../../Models/Reports/Tasks/appcc-report-model.service';

@Injectable({
  providedIn: 'root'
})
export class TasksReportsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public checklistsModel: ChecklistsReportModelService,
    public auditModel: AuditReportModelService,
    public appccModel: AppccReportModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener el informe de checklists
   *
   */
  public getChecklistsReport(filters: TasksReportFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEstadisticasChecklists', filters).subscribe({
        next: (response) => {
          if (save) {
            this.checklistsModel.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el informe de auditorías
   *
   */
  public getAuditsReport(filters: TasksReportFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEstadisticasAuditorias', filters).subscribe({
        next: (response) => {
          if (save) {
            this.auditModel.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el informe de APPCCs
   *
   */
  public getAppccsReport(filters: TasksReportFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEstadisticasAppccs', filters).subscribe({
        next: (response) => {
          if (save) {
            this.appccModel.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el detalle de la tarea en el informe
   *
   */
  public getTaskDetailReport(endpoint: string, params: TaskDetailReportParamsDto | null): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
